import { useMemo } from 'react'
import type { FactoryHookType } from '../type'
import maybeCreateVoltageAndCurrentFilterNode from './VoltageAndCurrentFilterNodeFactory'

const useVoltageAndCurrentFilterNode: FactoryHookType = ({ RendererComponent, options }) => {
  return useMemo(() => {
    return maybeCreateVoltageAndCurrentFilterNode({
      componentType: options.componentType,
      RendererComponent,
    })
  }, [options.componentType, RendererComponent])
}

export default useVoltageAndCurrentFilterNode
